<script>
	let { class: className } = $props();
</script>

<span class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="currentColor"
		viewBox="0 0 1000 1000"
	>
		<path
			fill="currentColor"
			d="M500 0A500 500 0 0 0 0 500a500 500 0 0 0 500 500c276 0 500-224 500-500S776 0 500 0zm0 150a166 166 0 1 1 0 332 166 166 0 1 1 0-332zm0 723c-91 0-174-33-238-88a70 70 0 0 1-25-54c0-93 75-168 168-168h193c93 0 168 75 168 168a70 70 0 0 1-25 54c-64 55-147 88-238 88z"
		/>
	</svg>
</span>
